module.exports = __webpack_public_path__ + "static/media/petpal logo-scrach.3859df4d.png";